var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiberyusInnova(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 25,
    viewBox: "0 0 137 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_689_3230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.646 17.129C132.646 19.1291 131.005 20.7494 128.978 20.7494C126.952 20.7494 125.311 19.1291 125.311 17.129C125.311 15.1289 126.952 13.5087 128.978 13.5087C131.005 13.5087 132.646 15.1289 132.646 17.129Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.81627H8.14338V25.0029H0V7.81627ZM2.37625 5.86796H5.76422C7.07625 5.86796 8.14046 4.81754 8.14046 3.5225V2.36848C8.14338 1.07056 7.07917 0.0201416 5.76713 0.0201416H2.37916C1.06421 0.0201416 0 1.07056 0 2.3656V3.51962C0 4.81466 1.06421 5.86508 2.37625 5.86508",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0573 -5.18241e-05H31.3848C34.385 -5.18241e-05 36.8196 2.40009 36.8196 5.36429V24.9999H28.5712V7.32699C28.5712 6.08951 27.5566 5.08801 26.3029 5.08801H21.4396C20.078 5.08801 18.973 6.17872 18.973 7.52268V24.9999H10.8296L10.7013 5.31536C10.6809 2.3857 13.0834 -0.00292969 16.0544 -0.00292969",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7723 25H75.1243C71.2436 25 68.0977 21.8948 68.0977 18.0643V6.6824C68.0977 2.99298 71.1299 0 74.8678 0H86.8277C90.7988 0 94.0177 3.17716 94.0177 7.09681V17.8456C94.0177 21.7969 90.7726 25 86.7694 25M85.7723 17.1751V7.67238C85.7723 6.27374 84.6235 5.13986 83.2065 5.13986H78.7864C77.3694 5.13986 76.2206 6.27374 76.2206 7.67238V17.1751C76.2206 18.6601 77.4394 19.863 78.9438 19.863H83.052C84.5564 19.863 85.7752 18.6601 85.7752 17.1751",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.468 0L104.91 18.7579V0H96.6562V19.7335C96.6562 22.643 99.0471 25 101.992 25H105.053C106.657 25 108.144 24.1712 108.969 22.8157L122.879 0H116.468Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6589 -5.18241e-05H59.9864C62.9866 -5.18241e-05 65.4211 2.40009 65.4211 5.36429V24.9999H57.1728V7.32699C57.1728 6.08951 56.1582 5.08801 54.9044 5.08801H50.0412C48.6796 5.08801 47.5745 6.17872 47.5745 7.52268V24.9999H39.4312L39.3029 5.31536C39.2825 2.3857 41.6849 -0.00292969 44.656 -0.00292969",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.665 0H128.604C127 0 125.513 0.828825 124.688 2.1843L110.777 25H117.189L128.746 6.24209V12.7432C128.822 12.7403 128.901 12.7374 128.98 12.7374C131.438 12.7374 133.432 14.7059 133.432 17.1319C133.432 19.558 131.44 21.5264 128.98 21.5264C128.901 21.5264 128.825 21.5264 128.746 21.5207V25.0058H137.001V5.26649C137.001 2.35697 134.61 0 131.665 0Z",
    fill: "black",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_689_3230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiberyusInnova);
export default __webpack_public_path__ + "static/media/liberyus-innova.4e241982915eec1236541a26fe1a4332.svg";
export { ForwardRef as ReactComponent };